import { useState } from "react";
import BaseInput from "../BaseInput";

const TextInput = ({ value, onInput, label, placeholder, size, className, variant = 'light', ...props }) => {
    const [localValue, setLocalValue] = useState(value || "");

    const handleChange = (newValue) => {
        // If size is defined, limit the newValue to that size
        const limitedValue = size ? newValue.slice(0, size) : newValue;
        setLocalValue(limitedValue);
        onInput(limitedValue);
    };

    return (
        <BaseInput
            {...props}
            value={localValue}
            onInput={handleChange}
            label={label}
            placeholder={placeholder}
            variant={variant}
            size={size}
            className={className}
            style={props.style}
        />
    );
};

export default TextInput;
